// extracted by mini-css-extract-plugin
export var container = "_dm-0";
export var containerTopRight = "_dm-1";